module.exports = __webpack_public_path__ + "img/水质监测.6d976b41.png";